/**
 * onboardingStore.js — first-visit detection for the new-user onboarding
 * flow (#304). Independent from `hintsStore.onboarded` (which gates the
 * hint-intensity intro #142); the greeter sets both so first-visit users
 * see a single welcome moment, not two stacked modals.
 *
 * Persistence: localStorage. Anonymous-tier behaviour is fine; logged-in
 * users on a fresh device should also see the greeter once.
 */

import { createSignal } from 'solid-js';

const KEY = 'redfur:onboarded.v1';

function load() {
  try { return localStorage.getItem(KEY) === '1'; } catch { return false; }
}

const [done, setDone] = createSignal(load());

export const onboarding = {
  done,
  isFirstVisit() { return !done(); },
  markComplete() {
    if (done()) return;
    setDone(true);
    try { localStorage.setItem(KEY, '1'); } catch { /* private mode — silent */ }
  },
};

export default onboarding;
